<template>
    <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
        <el-card class="box-card height" shadow="hover">
            <div class="box-card-head">
                <div class="operate-box">
                    <el-tooltip class="item" effect="dark" :content="$t('btns.edit')" placement="top-start">
                        <i class="el-icon-edit icon" @click="editDetail(buildData)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="$t('btns.delete')" placement="top-start">
                        <span class="el-icon-delete icon" @click="deleteDetail"></span>
                    </el-tooltip>
                </div>
            </div>
            <div class="residence-info">
                <div>
                    <p :title="buildData.description" class="residence-name">{{buildData.modulename}}</p>
                </div>
            </div>
            <ul class="card-actions clearfix">
                <li class="card-actions-item"  @click="showNextBuild(buildData)">
                    <a>查看下级</a>
                </li>
            </ul>
        </el-card>
    </el-col>
</template>

<script>
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'
import checkPermission from '@/utils/permission'
export default {
    name: "TheCard",
    props: ["buildData",],
    inject: ['reload'],
    data() {
        return {
			roomarr:[],
            building_index:0,
        };
    },
    components: {},
    methods: {
        // 查看下一级信息
        showNextBuild(data) {
            this.$emit("listenNextEvent", data);
        },
        // 删除区域信息
        deleteDetail() {
            if(!checkPermission('house')) {
                this.$notify({
                    title: '警告',
                    message: '暂无操作权限',
                    type: 'warning'
                });
                return
            }
            let info = this.buildData;
            $Alert(`确认删除${info.modulename}, 是否继续?`).then( async (bool)=>{
                if(bool){
                    let data = await Service.deleteBuild({OID:info.oid});
                    if(data) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!',
                            duration: 1500,
                        });
                        this.$emit("listenDeleteEvent");
                    }
                }   
            });
        },
        // 编辑区域信息
        editDetail(data) {
            if(!checkPermission('house')) {
                this.$notify({
                    title: '警告',
                    message: '暂无操作权限',
                    type: 'warning'
                });
                return
            }
            this.$emit("listenEditEvent", data);
        },
    }
};
</script>

<style scoped lang="less">
.box-card {
    position: relative;
    width: 100%;
    margin-bottom: 20px;
}
.box-card.height {
    height: 188px;
}
.box-card.card-height {
    height: 120px;
}
.box-card-head {
    display: flex;
    justify-content: flex-end;
    height: 30px;
}
.residence-name {
    font-size: 18px;
    color: #333;
}
.residence-info {
    display: table;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 90px;
    width: 100%;
    text-align: center;
}

.residence-info>div{
    display: table-cell;
    vertical-align: middle;
}

.card-actions {
    position: absolute;
    width: 100%;
    bottom: 0;
    margin: 20px -20px 0;
    background: #f7f9fa;
}
.card-actions > li:not(:last-child) {
    border-right: 1px solid #e8e8e8;
}
.card-actions-item {
    float: left;
    width: 100%;
    margin: 12px 0;
    font-size: 12px;
    text-align: center;
    color: rgba(0, 0, 0, 0.45);
    box-sizing: border-box;
    cursor: pointer;
}
.box-card.card-height .card-actions-item {
    width: calc(100% / 3);
}
.card-actions-item:hover {
    color: @primary-color;
}
.add-residence-box:hover {
    cursor: pointer;
    color: @primary-color;
}
</style>
